'use client';

import { c as _c } from "react/compiler-runtime";
import { Accordion } from '@uzh-bf/design-system';
import { useEffect, useMemo, useRef, useState } from 'react';
export default function UnitAccordionClient(t0) {
  const $ = _c(9);
  const {
    children,
    unitIds
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = [];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const [value, setValue] = useState(t1);
  let t2;
  if ($[1] !== unitIds) {
    t2 = new Set(unitIds);
    $[1] = unitIds;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const unitIdsSet = t2;
  const scrollTimeoutRef = useRef(undefined);
  let t3;
  let t4;
  if ($[3] !== unitIdsSet) {
    t3 = () => {
      const openFromHash = () => {
        const match = window.location.hash.match(/^#unit-(\d+)$/);
        if (!match) {
          return;
        }
        const unitId = match[1];
        const shouldOpen = unitIdsSet.has(unitId);
        setValue(shouldOpen ? [unitId] : []);
        if (!shouldOpen) {
          return;
        }
        if (scrollTimeoutRef.current) {
          window.clearTimeout(scrollTimeoutRef.current);
        }
        scrollTimeoutRef.current = window.setTimeout(() => {
          document.getElementById(`unit-${unitId}`)?.scrollIntoView({
            block: "start"
          });
        }, 220);
      };
      openFromHash();
      window.addEventListener("hashchange", openFromHash);
      return () => window.removeEventListener("hashchange", openFromHash);
    };
    t4 = [unitIdsSet];
    $[3] = unitIdsSet;
    $[4] = t3;
    $[5] = t4;
  } else {
    t3 = $[4];
    t4 = $[5];
  }
  useEffect(t3, t4);
  let t5;
  if ($[6] !== children || $[7] !== value) {
    t5 = <Accordion type="multiple" className="w-full" value={value} onValueChange={setValue}>{children}</Accordion>;
    $[6] = children;
    $[7] = value;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
}